import components from './components'
import mounted from './mounted'
import computed from './computed'
import methods from './methods'

export default {
  components,
  mounted,
  computed,
  methods
}



// WEBPACK FOOTER //
// ./src/app/professional/loading-page/gadget/resources/index.js